export default __webpack_public_path__ + "static/media/logo.bd577086.svg";